const METHOD = {
  GET: 'get',
  PATCH: 'patch',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
}
const METHOD_ACCESS_ROLE = {
  GET: 'Read',
  POST: 'Create',
  PUT: 'Update',
  DELETE: 'Delete'
}

const PREFIX_IMAGE = '/images'
const PREFIX_DOCUMENTS = '/documents'

const FILE_MAXIMUM_SIZE = 15

const STATUS = {
  ACTIVE: 'Aktif',
  INACTIVE: 'Tidak Aktif'
}

const STATUS_SYNC = {
  COMPLETED: 'Berhasil',
  RETRYING: 'Sedang Dicoba Ulang',
  INPROGRESS: 'Sedang Berjalan',
  PARTIAL_SUCCESS: 'Berhasil Sebagian',
  PENDING: 'Menunggu Sinkronisasi',
  FAILED: 'Gagal'
}

const TOOL_TIP = {
  FEE_REGISTRATION: 'Setiap peserta wajib membayar biaya pendaftaran minimal Rp. 0,- dan maksimal Rp. 50.000,-',
  FEE_STAMP_DUTY: 'Harap isi biaya materai dengan nominal yang sesuai. Jika tidak diperlukan, silakan masukkan angka 0',
  FEE_ADMINISTRATION: 'Setiap peserta wajib membayar biaya administrasi minimal Rp. 0,- dan maksimal Rp. 50.000,-',
  FEE_WITHDRAWAL_UNDER_THREE_YEAR: 'Maksimal persentase 2% dari dana yang ditarik',
  FEE_WITHDRAWAL_FOR_OVER_THREE_YEAR: 'Maksimal persentase 1% dari dana yang ditarik',
  FEE_TRANSFER_UNDER_THREE_YEAR: 'Maksimal persentase 3% dari dana yang dialihkan',
  FEE_TRANSFER_FOR_OVER_THREE_YEAR: 'Maksimal persentase 2% dari dana yang dialihkan',
  FEE_INVESTMENT_CHANGE: 'Jumlah persentase manfaat ke peserta minimal 0% dan maksimal 0,1% dari Total Aset Perusahaan'
}

const GENDER = [
  {
    id: '0',
    name: 'Perempuan',
    value: 'FEMALE'
  },
  {
    id: '1',
    name: 'Laki - Laki',
    value: 'MALE'
  }
]

const DOMICILE = [
  {
    id: '0',
    name: 'Sesuai',
    value: true
  },
  {
    id: '1',
    name: 'Tidak Sesuai',
    value: false
  }
]

const SORTING = [
  {
    name: 'Ascending',
    value: 'ASC'
  }, {
    name: 'Descending',
    value: 'DESC'
  }
]

export {
  METHOD,
  PREFIX_IMAGE,
  PREFIX_DOCUMENTS,
  FILE_MAXIMUM_SIZE,
  STATUS,
  STATUS_SYNC,
  TOOL_TIP,
  GENDER,
  DOMICILE,
  SORTING,
  METHOD_ACCESS_ROLE
}
